// @flow

import React, { Component } from 'react';
import styled from 'styled-components';
import SelectArrow from '../../../assets/gfx/select-arrow.svg';

const ArrowContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const StyledArrow = styled.img`
  transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  width: 20px;
  height: 11px;
  object-fit: contain;
  object-position: 50% 50%;
`;

export class Arrow extends Component<*> {
  render() {
    return (
      <ArrowContainer>
        <StyledArrow alt="arrow" src={SelectArrow} isOpen={this.props.isOpen} />
      </ArrowContainer>
    );
  }
}
